(function($) {
	'use strict';
	$.widget('msv.radiobutton', {
		vars: {}, //[{"value":1,"text":"1"},{"value":2,"text":"2"},{"value":3,"text":"3"},{"value":4,"text":"4"},{"value":5,"text":"5"}]
		el: {},
		_create: function() {
			var self = this;
			self.vars.labelText = self.element.data('label');
			self.vars.dataSource = self.element.data('json');
			self.vars.nameAttr = self.element.data('name');
		},
		_init: function() {
			var self = this;
			var inputName = self.vars.nameAttr ? " name='" + self.vars.nameAttr + "'" : "";
			self.el.input = $('<input type=hidden' + inputName + '>');
			this.element.html('');
			this.element.append(self.el.input);
			self.element.append('<div class="job-form__radio-btns-container__title js-radio-title">' + self.vars.labelText + '</div>');
			self.vars.dataSource.forEach(function(d) {
				self.element.append('<div class="job-form__radio-btns-container__bullet js-radio-item" data-value="' + d.value + '"><span>' + d.text + '</span> </div>');
			});

			self.element.find('.js-radio-item')
				.off('click')
				.click(function(e) {
					self.element.find('input[type=hidden]').val($(e.target).data('value'));
					self.element.find('.js-radio-item').removeClass('selected');
					$(e.target).addClass('selected');
				});
			$(window).resize(function() {
				self.redraw();
			});
		},
		_destroy: function() {},
		redraw: function() {
			var self = this;
			//console.log('redraw');
			//self.element.width(self.element.width() + 2);
		}
	});
})(jQuery);